import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import GreatestPremiumFull from './greatest-premium-full';

const GreatestPremiumFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <GreatestPremiumFull {...props} />
    </QueryClientProvider>
  );
};

export { GreatestPremiumFullWidget }
